import React from 'react';
import { Box } from '@mui/material';

const svgProps = {
  width: '100%',
  height: '100%',
  viewBox: '0 0 120 72',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};

function PreviewTable() {
  return (
    <svg {...svgProps} aria-hidden>
      <rect x="8" y="10" width="104" height="52" rx="4" stroke="currentColor" strokeWidth="2" opacity="0.35" />
      <rect x="8" y="10" width="104" height="14" fill="currentColor" opacity="0.2" />
      <line x1="8" y1="24" x2="112" y2="24" stroke="currentColor" strokeWidth="1.5" opacity="0.25" />
      <line x1="44" y1="10" x2="44" y2="62" stroke="currentColor" strokeWidth="1.5" opacity="0.25" />
      <line x1="78" y1="10" x2="78" y2="62" stroke="currentColor" strokeWidth="1.5" opacity="0.25" />
      <line x1="8" y1="38" x2="112" y2="38" stroke="currentColor" strokeWidth="1" opacity="0.15" />
      <line x1="8" y1="50" x2="112" y2="50" stroke="currentColor" strokeWidth="1" opacity="0.15" />
    </svg>
  );
}

function PreviewBar() {
  return (
    <svg {...svgProps} aria-hidden>
      <line x1="16" y1="58" x2="108" y2="58" stroke="currentColor" strokeWidth="2" opacity="0.35" />
      <rect x="22" y="34" width="14" height="24" rx="2" fill="currentColor" opacity="0.55" />
      <rect x="44" y="22" width="14" height="36" rx="2" fill="currentColor" opacity="0.75" />
      <rect x="66" y="40" width="14" height="18" rx="2" fill="currentColor" opacity="0.45" />
      <rect x="88" y="28" width="14" height="30" rx="2" fill="currentColor" opacity="0.65" />
    </svg>
  );
}

function PreviewLine() {
  return (
    <svg {...svgProps} aria-hidden>
      <line x1="16" y1="58" x2="108" y2="58" stroke="currentColor" strokeWidth="2" opacity="0.35" />
      <polyline
        points="18,46 36,38 54,42 72,24 90,30 104,18"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        opacity="0.8"
      />
      {[18, 36, 54, 72, 90, 104].map((x, i) => {
        const ys = [46, 38, 42, 24, 30, 18];
        return <circle key={x} cx={x} cy={ys[i]} r="3.5" fill="currentColor" opacity="0.85" />;
      })}
    </svg>
  );
}

function PreviewPie() {
  return (
    <svg {...svgProps} aria-hidden>
      <circle cx="60" cy="36" r="24" stroke="currentColor" strokeWidth="2" opacity="0.25" />
      <path d="M60 12 A24 24 0 0 1 82 46 L60 36 Z" fill="currentColor" opacity="0.75" />
      <path d="M82 46 A24 24 0 0 1 42 52 L60 36 Z" fill="currentColor" opacity="0.5" />
      <path d="M42 52 A24 24 0 0 1 60 12 L60 36 Z" fill="currentColor" opacity="0.35" />
    </svg>
  );
}

function PreviewRadar() {
  const center = [60, 36];
  return (
    <svg {...svgProps} aria-hidden>
      <polygon
        points="60,14 80.9,29.2 72.9,53.8 47.1,53.8 39.1,29.2"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
        opacity="0.25"
      />
      <polygon
        points="60,22 73.3,31.7 68.2,47.3 51.8,47.3 46.7,31.7"
        stroke="currentColor"
        strokeWidth="1"
        fill="none"
        opacity="0.2"
      />
      {['60,14', '80.9,29.2', '72.9,53.8', '47.1,53.8', '39.1,29.2'].map((p) => (
        <line
          key={p}
          x1={center[0]}
          y1={center[1]}
          x2={p.split(',')[0]}
          y2={p.split(',')[1]}
          stroke="currentColor"
          strokeWidth="1"
          opacity="0.2"
        />
      ))}
      <polygon
        points="60,16 69.5,32.9 69.4,48.9 55.3,42.5 46.7,31.7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
        fill="currentColor"
        fillOpacity="0.45"
        opacity="0.85"
      />
    </svg>
  );
}

function PreviewKpi() {
  return (
    <svg {...svgProps} aria-hidden>
      <rect x="20" y="16" width="80" height="40" rx="6" stroke="currentColor" strokeWidth="2" opacity="0.25" />
      <text x="60" y="42" textAnchor="middle" fontSize="22" fontWeight="700" fill="currentColor" opacity="0.85">
        128
      </text>
    </svg>
  );
}

const PREVIEW_BY_TYPE = {
  table: PreviewTable,
  bar: PreviewBar,
  line: PreviewLine,
  pie: PreviewPie,
  radar: PreviewRadar,
  kpi: PreviewKpi,
};

export default function ChartTypePreviewSvg({ type, sx }) {
  const Preview = PREVIEW_BY_TYPE[type] || PreviewBar;
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        color: 'primary.main',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx,
      }}
    >
      <Preview />
    </Box>
  );
}

export { PREVIEW_BY_TYPE };
